import {
  OrderStatus,
  TransactionType,
  TransactionStatus,
  SchemeProgress,
  SchemeType,
  ContractStatus
} from "@foxone/api/src/models/defi";
import { Colors } from "@/types";

const SchemeTypeMeta = {
  [SchemeType.NODE]: {
    text: "defi.enum.scheme-type.node"
  },
  [SchemeType.CURRENT]: {
    text: "defi.enum.scheme-type.current"
  },
  [SchemeType.POOL]: {
    text: "defi.enum.scheme-type.pool"
  },
  [SchemeType.TERM]: {
    text: "defi.enum.scheme-type.term"
  },
  [SchemeType.DUAL_NODE]: {
    text: "defi.enum.scheme-type.dualnode"
  }
};

const OrderStatusMeta = {
  [OrderStatus.UNPAID]: {
    text: "defi.enum.order-status.unpaid",
    color: Colors.RED
  },
  [OrderStatus.PAID]: {
    text: "defi.enum.order-status.paid",
    color: Colors.GREEN
  },
  [OrderStatus.CANCELD]: {
    text: "defi.enum.order-status.canceld",
    color: Colors.GRAY
  },
  [OrderStatus.UNKNOWN]: {
    text: "defi.enum.order-status.unknown",
    color: Colors.GRAY
  }
};

const TransactionTypeMeta = {
  [TransactionType.DEFAULT]: {
    text: "defi.enum.transaction-type.default",
    color: Colors.GRAY
  },
  [TransactionType.INCOME]: {
    text: "defi.enum.transaction-type.income",
    color: Colors.RED
  },
  [TransactionType.INTEREST]: {
    text: "defi.enum.transaction-type.interest",
    color: Colors.RED
  },
  [TransactionType.ORDER]: {
    text: "defi.enum.transaction-type.order",
    color: Colors.RED
  },
  [TransactionType.REFUND]: {
    text: "defi.enum.transaction-type.refund",
    color: Colors.GREEN
  },
  [TransactionType.RETURN]: {
    text: "defi.enum.transaction-type.return",
    color: Colors.GREEN
  },
  [TransactionType.TRANSFER]: {
    text: "defi.enum.transaction-type.transfer",
    color: Colors.GRAY
  },
  [TransactionType.WITHDRAW]: {
    text: "defi.enum.transaction-type.withdraw",
    color: Colors.GREEN
  },
  [TransactionType.LIQUIDATION]: {
    text: "defi.enum.transaction-type.liquidation",
    color: Colors.GREEN
  }
};

const TransactionStatusMeta = {
  [TransactionStatus.PENDING]: {
    text: "defi.enum.transaction-status.pending",
    color: Colors.WARNING
  },
  [TransactionStatus.FAIL]: {
    text: "defi.enum.transaction-status.fail",
    color: Colors.RED
  },
  [TransactionStatus.SUCCESS]: {
    text: "defi.enum.transaction-status.sucess",
    color: Colors.GREEN
  }
};

const SchemeProgressMeta = {
  [SchemeProgress.FULL]: {
    text: "defi.enum.node-progress.full",
    color: Colors.GRAY
  },
  [SchemeProgress.OPENING]: {
    text: "defi.enum.node-progress.opening",
    color: Colors.GREEN
  },
  [SchemeProgress.PRE_OPEN]: {
    text: "defi.enum.node-progress.pre_open",
    color: Colors.GREEN
  },
  [SchemeProgress.RUNNING]: {
    text: "defi.enum.node-progress.running",
    color: Colors.GREEN
  },
  [SchemeProgress.CLOSED]: {
    text: "defi.enum.node-progress.closed",
    color: Colors.GRAY
  }
};

const ContractStatusMeta = {
  [ContractStatus.RUNNING]: {
    text: "defi.enum.contract-status-meta.running",
    color: Colors.GREEN
  },
  [ContractStatus.SETTLEMENT]: {
    text: "defi.enum.contract-status-meta.settlement",
    color: Colors.GREEN
  },
  [ContractStatus.REDEMPTION]: {
    text: "defi.enum.contract-status-meta.redemption",
    color: Colors.GREEN
  },
  [ContractStatus.CLOSED]: {
    text: "defi.enum.contract-status-meta.closed",
    color: Colors.RED
  }
};

export default {
  getSchemeTypeMeta(type: SchemeType) {
    return SchemeTypeMeta[type];
  },

  getOrderStatusMeta(status: OrderStatus) {
    return OrderStatusMeta[status];
  },

  getTransactionTypeMeta(type: TransactionType) {
    return TransactionTypeMeta[type];
  },

  getTransactionStatusMeta(status: TransactionStatus) {
    return TransactionStatusMeta[status];
  },

  getSchemeProgressMeta(progress: SchemeProgress) {
    return SchemeProgressMeta[progress];
  },

  getContractStatusMeta(status: ContractStatus) {
    return ContractStatusMeta[status];
  }
};
